//there are no filters other than the standard include 'archived'
export const filters = () => {
  return {
    RegularFilters: [
      {
        label: 'Archived',
        field: 'archived',
        type: 'toggle',
      },
    ],
  };
};
